import { useEffect } from 'react';

const runtimeBrandProperties = [
  '--color-brand-default',
  '--color-brand-hover',
  '--color-brand-pressed',
  '--color-brand-loading',
  '--color-overlay-brand-focused',
  '--color-overlay-brand-hover',
  '--color-overlay-brand-pressed',
] as const;

const useColorTheme = () => {
  useEffect(() => {
    // Use the shared neutral palette instead of runtime tenant branding.
    for (const property of runtimeBrandProperties) {
      document.body.style.removeProperty(property);
    }
  }, []);
};

export default useColorTheme;
